import { render, staticRenderFns } from "./BioBreakDetails.vue?vue&type=template&id=25f17550&"
import script from "./BioBreakDetails.vue?vue&type=script&lang=js&"
export * from "./BioBreakDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports